function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var ISSUANCE_TRANSACTION_TYPE = 6;
var NOLAN_PER_SAITO = 100000000n;
var DEFAULT_SUPPLY_NOLAN = 7000000000n * NOLAN_PER_SAITO;
var EMPTY_BLOCK_HASH = '0000000000000000000000000000000000000000000000000000000000000000';
var MAX_CONSECUTIVE_BACKFILL_FAILURES = 5;
var activeSupplyBackfills = new WeakMap();
var _require = require('./address-index'),
  returnGenesisPeriod = _require.returnGenesisPeriod;
function toBigInt(value) {
  if (value === undefined || value === null || value === '') {
    return 0n;
  }
  try {
    return BigInt(value);
  } catch (err) {
    return 0n;
  }
}
function toStorage(value) {
  if (value === undefined || value === null) {
    return '0';
  }
  if (typeof value === 'bigint') {
    return value.toString();
  }
  if (typeof value === 'boolean') {
    return value ? '1' : '0';
  }
  return String(value);
}
function toNullableStorage(value) {
  if (value === undefined || value === null) {
    return null;
  }
  return toStorage(value);
}
function slipAmountValue(slip) {
  if (slip == null) {
    return 0n;
  }
  try {
    var _slip$amount;
    return BigInt((_slip$amount = slip.amount) !== null && _slip$amount !== void 0 ? _slip$amount : 0);
  } catch (err) {
    return 0n;
  }
}
function normalizeTransaction(tx) {
  var _tx$type2;
  if (!tx) {
    return null;
  }
  if (typeof tx.toJson === 'function') {
    var _ref, _ref2, _tx$type;
    var json = {};
    try {
      json = JSON.parse(tx.toJson());
    } catch (err) {
      json = {};
    }
    return {
      type: (_ref = (_ref2 = (_tx$type = tx.type) !== null && _tx$type !== void 0 ? _tx$type : tx.transaction_type) !== null && _ref2 !== void 0 ? _ref2 : json.type) !== null && _ref !== void 0 ? _ref : json.transaction_type,
      to: Array.isArray(tx.to) ? tx.to : json.to || []
    };
  }
  return {
    type: (_tx$type2 = tx.type) !== null && _tx$type2 !== void 0 ? _tx$type2 : tx.transaction_type,
    to: Array.isArray(tx.to) ? tx.to : []
  };
}
function isIssuanceTransaction(tx) {
  var _tx$type3;
  if (!tx) {
    return false;
  }
  var type = (_tx$type3 = tx.type) !== null && _tx$type3 !== void 0 ? _tx$type3 : tx.transaction_type;
  return Number(type) === ISSUANCE_TRANSACTION_TYPE || type === 'Issuance';
}
function isGenesisBlock(block) {
  var _block$id;
  var blockId = Number((_block$id = block === null || block === void 0 ? void 0 : block.id) !== null && _block$id !== void 0 ? _block$id : 0);
  if (blockId === 1) {
    return true;
  }
  var previousHash = String((block === null || block === void 0 ? void 0 : block.previousBlockHash) || '').trim();
  return !previousHash || previousHash === EMPTY_BLOCK_HASH;
}
function sumIssuanceFromBlock(block) {
  var total = 0n;
  var txs = (block === null || block === void 0 ? void 0 : block.transactions) || [];
  for (var i = 0; i < txs.length; i++) {
    var tx = normalizeTransaction(txs[i]);
    if (!tx || !isIssuanceTransaction(tx)) {
      continue;
    }
    var outputs = tx.to || [];
    for (var j = 0; j < outputs.length; j++) {
      total += slipAmountValue(outputs[j]);
    }
  }
  return total;
}
function readHeaderBuckets(block) {
  return {
    treasury: toBigInt(block === null || block === void 0 ? void 0 : block.treasury),
    graveyard: toBigInt(block === null || block === void 0 ? void 0 : block.graveyard),
    total_fees: toBigInt(block === null || block === void 0 ? void 0 : block.totalFees),
    previous_block_unpaid: toBigInt(block === null || block === void 0 ? void 0 : block.previousBlockUnpaid)
  };
}
function deriveUtxoFromSupply(totalSupply, buckets) {
  var blockId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var utxo = totalSupply - buckets.treasury - buckets.graveyard - buckets.total_fees - buckets.previous_block_unpaid;
  if (utxo < 0n) {
    console.warn('Explorer: negative derived UTXO for supply accounting', {
      block_id: blockId,
      total_supply: totalSupply.toString(),
      treasury: buckets.treasury.toString(),
      graveyard: buckets.graveyard.toString(),
      total_fees: buckets.total_fees.toString(),
      previous_block_unpaid: buckets.previous_block_unpaid.toString()
    });
  }
  return utxo < 0n ? 0n : utxo;
}
function blockIdString(block) {
  if ((block === null || block === void 0 ? void 0 : block.id) == null) {
    return '';
  }
  return String(block.id);
}
function balanceSnapshotTip(fileName) {
  var match = String(fileName || '').match(/^(\d+)-(\d+)-([0-9a-f]{64})\.snap$/i);
  if (!match) {
    return null;
  }
  return {
    block_id: match[2],
    block_hash: match[3].toLowerCase()
  };
}
function sumBalanceSnapshotRows(rows) {
  if (!rows || typeof rows[Symbol.iterator] !== 'function') {
    throw new Error('balance snapshot has no iterable rows');
  }
  var total = 0n;
  var _iterator = _createForOfIteratorHelper(rows),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      var columns = String(row || '').trim().split(/\s+/);
      if (columns.length !== 6 || !/^\d+$/.test(columns[4])) {
        throw new Error('balance snapshot contains an invalid row');
      }
      total += BigInt(columns[4]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return total;
}
function readBalanceSnapshotSupply(_x, _x2, _x3) {
  return _readBalanceSnapshotSupply.apply(this, arguments);
}
function _readBalanceSnapshotSupply() {
  _readBalanceSnapshotSupply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mod, block, buckets) {
    var snapshot, tip, calculatedTotalSupply, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!(typeof (mod === null || mod === void 0 ? void 0 : mod.getSupplyBalanceSnapshot) !== 'function')) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          _context.p = 1;
          _context.n = 2;
          return mod.getSupplyBalanceSnapshot();
        case 2:
          snapshot = _context.v;
          tip = balanceSnapshotTip(snapshot === null || snapshot === void 0 ? void 0 : snapshot.file_name);
          if (tip) {
            _context.n = 3;
            break;
          }
          return _context.a(2, null);
        case 3:
          if (!(blockIdString(block) !== tip.block_id || String((block === null || block === void 0 ? void 0 : block.hash) || '').toLowerCase() !== tip.block_hash)) {
            _context.n = 4;
            break;
          }
          return _context.a(2, null);
        case 4:
          calculatedTotalSupply = sumBalanceSnapshotRows(snapshot.rows);
          return _context.a(2, {
            calculated_total_supply: calculatedTotalSupply,
            utxo_graveyard_treasury_total: calculatedTotalSupply + buckets.graveyard + buckets.treasury
          });
        case 5:
          _context.p = 5;
          _t = _context.v;
          console.warn('Explorer: failed to read balance snapshot for supply accounting', _t);
          return _context.a(2, null);
      }
    }, _callee, null, [[1, 5]]);
  }));
  return _readBalanceSnapshotSupply.apply(this, arguments);
}
function resolveGenesisTotalSupply(_x4) {
  return _resolveGenesisTotalSupply.apply(this, arguments);
}
function _resolveGenesisTotalSupply() {
  _resolveGenesisTotalSupply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(block) {
    var issuanceTotal;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          issuanceTotal = sumIssuanceFromBlock(block);
          if (!(issuanceTotal > 0n)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, issuanceTotal);
        case 1:
          return _context2.a(2, DEFAULT_SUPPLY_NOLAN);
      }
    }, _callee2);
  }));
  return _resolveGenesisTotalSupply.apply(this, arguments);
}
function resolveTotalSupply(_x5, _x6, _x7, _x8) {
  return _resolveTotalSupply.apply(this, arguments);
}
function _resolveTotalSupply() {
  _resolveTotalSupply = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, mod, block, buckets) {
    var _mod$database;
    var parentHash, parentRow, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          if (!isGenesisBlock(block)) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2, resolveGenesisTotalSupply(block));
        case 1:
          parentHash = String((block === null || block === void 0 ? void 0 : block.previousBlockHash) || '').trim();
          if (!(!parentHash || parentHash === EMPTY_BLOCK_HASH)) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, resolveGenesisTotalSupply(block));
        case 2:
          if (!(mod !== null && mod !== void 0 && (_mod$database = mod.database) !== null && _mod$database !== void 0 && _mod$database.getStatisticsByBlockHash)) {
            _context3.n = 4;
            break;
          }
          _context3.n = 3;
          return mod.database.getStatisticsByBlockHash(parentHash);
        case 3:
          _t2 = _context3.v;
          _context3.n = 5;
          break;
        case 4:
          _t2 = null;
        case 5:
          parentRow = _t2;
          if (!((parentRow === null || parentRow === void 0 ? void 0 : parentRow.total_supply) != null && parentRow.total_supply !== '')) {
            _context3.n = 6;
            break;
          }
          return _context3.a(2, toBigInt(parentRow.total_supply));
        case 6:
          return _context3.a(2, DEFAULT_SUPPLY_NOLAN);
      }
    }, _callee3);
  }));
  return _resolveTotalSupply.apply(this, arguments);
}
function computeSupplyBuckets(_x9, _x0, _x1) {
  return _computeSupplyBuckets.apply(this, arguments);
}
function _computeSupplyBuckets() {
  _computeSupplyBuckets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, mod, block) {
    var _consensusSupply$calc, _consensusSupply$utxo;
    var options,
      buckets,
      totalSupply,
      utxo,
      consensusSupply,
      _args4 = arguments,
      _t3;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          options = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
          buckets = readHeaderBuckets(block);
          _context4.n = 1;
          return resolveTotalSupply(app, mod, block, buckets);
        case 1:
          totalSupply = _context4.v;
          utxo = deriveUtxoFromSupply(totalSupply, buckets, blockIdString(block));
          if (!(options.calculateSnapshot === false)) {
            _context4.n = 2;
            break;
          }
          _t3 = null;
          _context4.n = 4;
          break;
        case 2:
          _context4.n = 3;
          return readBalanceSnapshotSupply(mod, block, buckets);
        case 3:
          _t3 = _context4.v;
        case 4:
          consensusSupply = _t3;
          return _context4.a(2, _objectSpread({
            utxo: utxo,
            total_supply: totalSupply,
            calculated_total_supply: (_consensusSupply$calc = consensusSupply === null || consensusSupply === void 0 ? void 0 : consensusSupply.calculated_total_supply) !== null && _consensusSupply$calc !== void 0 ? _consensusSupply$calc : null,
            utxo_graveyard_treasury_total: (_consensusSupply$utxo = consensusSupply === null || consensusSupply === void 0 ? void 0 : consensusSupply.utxo_graveyard_treasury_total) !== null && _consensusSupply$utxo !== void 0 ? _consensusSupply$utxo : null
          }, buckets));
      }
    }, _callee4);
  }));
  return _computeSupplyBuckets.apply(this, arguments);
}
function buildBlockSupplyStats(_x10, _x11, _x12) {
  return _buildBlockSupplyStats.apply(this, arguments);
}
function _buildBlockSupplyStats() {
  _buildBlockSupplyStats = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app, mod, block) {
    var options,
      id,
      hash,
      totalFees,
      totalFeesNew,
      totalFeesAtr,
      totalFeesCumulative,
      avgTotalFees,
      avgTotalFeesNew,
      avgTotalFeesAtr,
      totalPayoutRouting,
      totalPayoutMining,
      totalPayoutTreasury,
      totalPayoutGraveyard,
      totalPayoutAtr,
      avgPayoutRouting,
      avgPayoutMining,
      avgPayoutTreasury,
      avgPayoutGraveyard,
      avgPayoutAtr,
      avgFeePerByte,
      feePerByte,
      avgNolanRebroadcastPerBlock,
      burnFee,
      difficulty,
      previousBlockUnpaid,
      hasGoldenTicket,
      treasury,
      graveyard,
      supply,
      stats,
      _args5 = arguments;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          options = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : {};
          id = block.id, hash = block.hash, totalFees = block.totalFees, totalFeesNew = block.totalFeesNew, totalFeesAtr = block.totalFeesAtr, totalFeesCumulative = block.totalFeesCumulative, avgTotalFees = block.avgTotalFees, avgTotalFeesNew = block.avgTotalFeesNew, avgTotalFeesAtr = block.avgTotalFeesAtr, totalPayoutRouting = block.totalPayoutRouting, totalPayoutMining = block.totalPayoutMining, totalPayoutTreasury = block.totalPayoutTreasury, totalPayoutGraveyard = block.totalPayoutGraveyard, totalPayoutAtr = block.totalPayoutAtr, avgPayoutRouting = block.avgPayoutRouting, avgPayoutMining = block.avgPayoutMining, avgPayoutTreasury = block.avgPayoutTreasury, avgPayoutGraveyard = block.avgPayoutGraveyard, avgPayoutAtr = block.avgPayoutAtr, avgFeePerByte = block.avgFeePerByte, feePerByte = block.feePerByte, avgNolanRebroadcastPerBlock = block.avgNolanRebroadcastPerBlock, burnFee = block.burnFee, difficulty = block.difficulty, previousBlockUnpaid = block.previousBlockUnpaid, hasGoldenTicket = block.hasGoldenTicket, treasury = block.treasury, graveyard = block.graveyard;
          _context5.n = 1;
          return computeSupplyBuckets(app, mod, block, options);
        case 1:
          supply = _context5.v;
          stats = {
            block_id: toStorage(id),
            block_hash: hash,
            treasury: toStorage(treasury),
            graveyard: toStorage(graveyard),
            total_fees: toStorage(totalFees),
            total_fees_new: toStorage(totalFeesNew),
            total_fees_atr: toStorage(totalFeesAtr),
            total_fees_cumulative: toStorage(totalFeesCumulative),
            avg_total_fees: toStorage(avgTotalFees),
            avg_total_fees_new: toStorage(avgTotalFeesNew),
            avg_total_fees_atr: toStorage(avgTotalFeesAtr),
            total_payout_routing: toStorage(totalPayoutRouting),
            total_payout_mining: toStorage(totalPayoutMining),
            total_payout_treasury: toStorage(totalPayoutTreasury),
            total_payout_graveyard: toStorage(totalPayoutGraveyard),
            total_payout_atr: toStorage(totalPayoutAtr),
            avg_payout_routing: toStorage(avgPayoutRouting),
            avg_payout_mining: toStorage(avgPayoutMining),
            avg_payout_treasury: toStorage(avgPayoutTreasury),
            avg_payout_graveyard: toStorage(avgPayoutGraveyard),
            avg_payout_atr: toStorage(avgPayoutAtr),
            avg_fee_per_byte: toStorage(avgFeePerByte),
            fee_per_byte: toStorage(feePerByte),
            avg_nolan_rebroadcast_per_block: toStorage(avgNolanRebroadcastPerBlock),
            burn_fee: toStorage(burnFee),
            difficulty: toStorage(difficulty),
            previous_block_unpaid: toStorage(previousBlockUnpaid),
            has_golden_ticket: toStorage(hasGoldenTicket),
            utxo: toStorage(supply.utxo),
            total_supply: toStorage(supply.total_supply),
            calculated_total_supply: toNullableStorage(supply.calculated_total_supply),
            utxo_graveyard_treasury_total: toNullableStorage(supply.utxo_graveyard_treasury_total)
          };
          return _context5.a(2, stats);
      }
    }, _callee5);
  }));
  return _buildBlockSupplyStats.apply(this, arguments);
}
function ensureBlockSupplyIndexed(_x13, _x14, _x15) {
  return _ensureBlockSupplyIndexed.apply(this, arguments);
}
function _ensureBlockSupplyIndexed() {
  _ensureBlockSupplyIndexed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app, mod, block) {
    var _mod$database2;
    var options,
      stats,
      result,
      reason,
      err,
      _args6 = arguments;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          options = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
          if (!(!(block !== null && block !== void 0 && block.hash) || !(mod !== null && mod !== void 0 && (_mod$database2 = mod.database) !== null && _mod$database2 !== void 0 && _mod$database2.upsertBlockStatistics))) {
            _context6.n = 1;
            break;
          }
          return _context6.a(2, null);
        case 1:
          _context6.n = 2;
          return buildBlockSupplyStats(app, mod, block, options);
        case 2:
          stats = _context6.v;
          _context6.n = 3;
          return mod.database.upsertBlockStatistics(stats);
        case 3:
          result = _context6.v;
          if (result !== null && result !== void 0 && result.success) {
            _context6.n = 4;
            break;
          }
          reason = (result === null || result === void 0 ? void 0 : result.reason) || 'unknown database error';
          err = new Error("Explorer: failed to store supply statistics for block ".concat(stats.block_id, ": ").concat(reason));
          err.code = 'EXPLORER_SUPPLY_WRITE_FAILED';
          throw err;
        case 4:
          return _context6.a(2, stats);
      }
    }, _callee6);
  }));
  return _ensureBlockSupplyIndexed.apply(this, arguments);
}
function isBlockHash(hash) {
  return typeof hash === 'string' && hash !== EMPTY_BLOCK_HASH && /^[0-9a-f]{64}$/i.test(hash);
}
function hasSupplyStatistics(row) {
  return (row === null || row === void 0 ? void 0 : row.total_supply) != null && row.total_supply !== '';
}
function hasCalculatedSupply(row) {
  return (row === null || row === void 0 ? void 0 : row.calculated_total_supply) != null && row.calculated_total_supply !== '';
}
function backfillStartId(app, latestId) {
  var _app$options;
  var genesisPeriod = Math.max(1, returnGenesisPeriod(app));
  var genesisFloor = Math.max(1, latestId - genesisPeriod + 1);
  var savedLowest = Number(app === null || app === void 0 || (_app$options = app.options) === null || _app$options === void 0 || (_app$options = _app$options.blockchain) === null || _app$options === void 0 ? void 0 : _app$options.lowest_acceptable_block_id);
  var savedFloor = Number.isFinite(savedLowest) && savedLowest > 0 ? Math.floor(savedLowest) : 1;
  return Math.max(1, genesisFloor, savedFloor);
}
function runSupplyStatisticsBackfill(_x16, _x17) {
  return _runSupplyStatisticsBackfill.apply(this, arguments);
}
function _runSupplyStatisticsBackfill() {
  _runSupplyStatisticsBackfill = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(app, mod) {
    var summary, latestId, firstBlockId, consecutiveFailures, blockId, blockHash, existing, needsLatestConsensusSnapshot, block, _t4, _t5, _t6;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          summary = {
            scanned: 0,
            indexed: 0,
            already_indexed: 0,
            unavailable: 0,
            failed: 0
          };
          if (!(!(mod !== null && mod !== void 0 && mod.database) || app.BROWSER !== 0)) {
            _context7.n = 1;
            break;
          }
          return _context7.a(2, summary);
        case 1:
          latestId = 0;
          _context7.p = 2;
          _t4 = Number;
          _context7.n = 3;
          return app.blockchain.getLatestBlockId();
        case 3:
          latestId = _t4(_context7.v);
          _context7.n = 5;
          break;
        case 4:
          _context7.p = 4;
          _t5 = _context7.v;
          console.error('Explorer: supply backfill could not read latest block id', _t5);
          return _context7.a(2, summary);
        case 5:
          if (!(!Number.isFinite(latestId) || latestId <= 0)) {
            _context7.n = 6;
            break;
          }
          return _context7.a(2, summary);
        case 6:
          firstBlockId = backfillStartId(app, latestId);
          consecutiveFailures = 0;
          blockId = firstBlockId;
        case 7:
          if (!(blockId <= latestId)) {
            _context7.n = 19;
            break;
          }
          summary.scanned++;
          _context7.p = 8;
          _context7.n = 9;
          return app.blockchain.getLongestChainHashAtId(BigInt(blockId));
        case 9:
          blockHash = _context7.v;
          if (isBlockHash(blockHash)) {
            _context7.n = 10;
            break;
          }
          summary.unavailable++;
          consecutiveFailures = 0;
          return _context7.a(3, 18);
        case 10:
          _context7.n = 11;
          return mod.database.getStatisticsByBlockHash(blockHash);
        case 11:
          existing = _context7.v;
          needsLatestConsensusSnapshot = blockId === latestId && typeof (mod === null || mod === void 0 ? void 0 : mod.getSupplyBalanceSnapshot) === 'function';
          if (!(hasSupplyStatistics(existing) && (!needsLatestConsensusSnapshot || hasCalculatedSupply(existing)))) {
            _context7.n = 12;
            break;
          }
          summary.already_indexed++;
          consecutiveFailures = 0;
          return _context7.a(3, 18);
        case 12:
          _context7.n = 13;
          return app.core.blockchain.getBlock(blockHash, true);
        case 13:
          block = _context7.v;
          if (block !== null && block !== void 0 && block.hash) {
            _context7.n = 14;
            break;
          }
          summary.unavailable++;
          consecutiveFailures = 0;
          return _context7.a(3, 18);
        case 14:
          _context7.n = 15;
          return ensureBlockSupplyIndexed(app, mod, block, {
            calculateSnapshot: blockId === latestId
          });
        case 15:
          summary.indexed++;
          consecutiveFailures = 0;
          _context7.n = 18;
          break;
        case 16:
          _context7.p = 16;
          _t6 = _context7.v;
          if (!((_t6 === null || _t6 === void 0 ? void 0 : _t6.code) === 'EXPLORER_SUPPLY_WRITE_FAILED')) {
            _context7.n = 17;
            break;
          }
          throw _t6;
        case 17:
          summary.failed++;
          consecutiveFailures++;
          if (consecutiveFailures === 1) {
            console.error("Explorer: supply backfill failed for block ".concat(blockId), _t6);
          }
          if (!(consecutiveFailures >= MAX_CONSECUTIVE_BACKFILL_FAILURES)) {
            _context7.n = 18;
            break;
          }
          throw new Error("Explorer: aborting supply backfill after ".concat(consecutiveFailures, " consecutive failures ") + "(last block ".concat(blockId, ")"));
        case 18:
          blockId++;
          _context7.n = 7;
          break;
        case 19:
          if (summary.failed > 0) {
            console.warn('Explorer: supply backfill completed with recoverable failures', summary);
          }
          return _context7.a(2, summary);
      }
    }, _callee7, null, [[8, 16], [2, 4]]);
  }));
  return _runSupplyStatisticsBackfill.apply(this, arguments);
}
function backfillSupplyStatistics(app, mod) {
  if (!mod || _typeof(mod) !== 'object' && typeof mod !== 'function') {
    return Promise.resolve();
  }
  var activeBackfill = activeSupplyBackfills.get(mod);
  if (activeBackfill) {
    return activeBackfill;
  }
  var backfill = runSupplyStatisticsBackfill(app, mod)["finally"](function () {
    if (activeSupplyBackfills.get(mod) === backfill) {
      activeSupplyBackfills["delete"](mod);
    }
  });
  activeSupplyBackfills.set(mod, backfill);
  return backfill;
}
module.exports = {
  DEFAULT_SUPPLY_NOLAN: DEFAULT_SUPPLY_NOLAN,
  NOLAN_PER_SAITO: NOLAN_PER_SAITO,
  ISSUANCE_TRANSACTION_TYPE: ISSUANCE_TRANSACTION_TYPE,
  buildBlockSupplyStats: buildBlockSupplyStats,
  computeSupplyBuckets: computeSupplyBuckets,
  ensureBlockSupplyIndexed: ensureBlockSupplyIndexed,
  backfillSupplyStatistics: backfillSupplyStatistics,
  sumIssuanceFromBlock: sumIssuanceFromBlock,
  sumBalanceSnapshotRows: sumBalanceSnapshotRows,
  balanceSnapshotTip: balanceSnapshotTip,
  isGenesisBlock: isGenesisBlock,
  toStorage: toStorage
};